<template>
  <section :id="data.id" class="bg-gray-lighten3 py-6 xl:py-8">
    <div class="container text-center">
      <ul
        class="inline-flex max-w-[calc(212px*2)] flex-wrap justify-center sm:max-w-[calc(212px*4)] md:max-w-[calc(212px*6)] xl:max-w-[calc(212px*8)] 3xl:max-w-none"
      >
        <li
          v-for="(benefit, i) in data.benefits"
          :key="i"
          class="flex max-w-[212px] grow basis-2/4 flex-col sm:basis-1/4 md:basis-1/6 xl:basis-[calc(100%/8*1)]"
        >
          <ProductBenefitsItem
            class="grow"
            :icon="benefit.icon"
            :title="benefit.title"
            :description="benefit.description"
          />
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import ProductBenefitsItem from '~/components/sections/productSection/ProductBenefitsItem.vue';

interface Props {
  data?: any;
}

withDefaults(defineProps<Props>(), {
  data: () => ({}),
});
</script>

<style lang="scss" scoped>
ul {
  margin-top: -24px;
  li {
    margin-top: 24px;
    padding: 0 16px;
    @media screen and (min-width: 768px) {
      border-right: 1px solid rgba(51, 63, 72, 0.2);
    }
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
      border-right: 0;
    }

    &:nth-child(4n) {
      @media screen and (min-width: 768px) and (max-width: 1023px) {
        border-right: 0;
      }
    }
    &:nth-child(6n) {
      @media screen and (min-width: 1024px) and (max-width: 1439px) {
        border-right: 0;
      }
    }
    &:nth-child(8n) {
      @media screen and (min-width: 1440px) {
        border-right: 0;
      }
    }
    &:nth-child(odd) {
      &:not(:last-child) {
        @media screen and (max-width: 767px) {
          border-right: 1px solid rgba(51, 63, 72, 0.2);
        }
      }
    }
  }
}
</style>
